/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useState } from "react";
import LpCivilServiceLawPartner from "./LpCivilServiceLawPartner";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";
import { apiPost } from "@/src/services/apiClient";

const LpCivilServiceLawHuk = () => {
  const [error, setError] = useState("");

  const preCheckinSubmit = async (values: Record<string, any>) => {
    const status = await apiPost("/partner/insurance_coverage", {
      partnerName: "hukCoburg",
      insurancePolicyNumber: values.caseInsurance.insurancePolicyNumber,
      productName: "civilServiceLaw",
    });

    switch (status) {
      case "notCovered":
        setError("Leider konnten wir Ihre Versicherungsnummer nicht verifizieren. Bitte versuchen Sie es erneut.");
        return false;
      case "error":
        setError("Leider konnten wir den Versicherungsstatus bei der HUK aktuell nicht ermitteln. Bitte versuchen Sie es später erneut.");
        return false;
      default:
        setError("");
        return true;
    }
  };

  return <LpCivilServiceLawPartner partner={PARTNER_IRIS.HUK_COBURG} preCheckinSubmit={preCheckinSubmit} externalError={error} />;
};

export default LpCivilServiceLawHuk;
